import { cn } from "@faire/web/tools/cn";

import { topVar, transitionDurationVar } from "./consts.css";

type Arg = {
  nonStickyHeader: boolean;
  shouldRetainOriginalPosition: boolean;
};

export const useClassName = ({
  nonStickyHeader,
  shouldRetainOriginalPosition,
}: Arg) => {
  return nonStickyHeader
    ? "relative z-12"
    : cn(
        "transition-top sticky z-12",
        topVar.className,
        transitionDurationVar.className,
        shouldRetainOriginalPosition
          ? "ease-[cubic-bezier(0.1,0.7,0.6,1)]"
          : "ease-linear"
      );
};
